export default "__VITE_ASSET__DRhK6j6V__"